import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Col, Row } from "react-bootstrap";
import { useAuth } from "../context/useAuth";
import { useNavigate } from "react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Forms.css";

export default function LoginForm() {
    const [t, i18n] = useTranslation("global");
    const { loginUser } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const handleLogin = async (e: any) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const payload = Object.fromEntries(formData);
        try {
            loginUser(payload.username.toString(), payload.password.toString());
        } catch (error) {
            setError(t("login.error"));
        }
    };

    return (
        <>
            <div className="d-flex justify-content-center mt-5">
                <Form className="w-50" onSubmit={handleLogin}>
                    <h1 className="mt-5 mb-5">{t("login.title")}</h1>
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}
                    <Row>
                        <Col xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="formUsername"
                            >
                                <Form.Label>
                                    {t("login.form.username")}
                                </Form.Label>
                                <Form.Control
                                    required
                                    className="custom-input"
                                    name="username"
                                    type="text"
                                    placeholder={t(
                                        "login.form.placeholder-username"
                                    )}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="formPassword"
                            >
                                <Form.Label>
                                    {t("login.form.password")}
                                </Form.Label>
                                <Form.Control
                                    required
                                    className="custom-input"
                                    name="password"
                                    type="password"
                                    placeholder={t(
                                        "login.form.placeholder-password"
                                    )}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Button
                                variant="primary custom-button"
                                type="submit"
                                className="w-100"
                            >
                                {t("buttons.login")}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
}
